export default __webpack_public_path__ + "static/media/bathroom2-afterA-1440w.23f4b2dd.avif";